<template>
  <main v-if="true" :class="{'boxPadding': isBox}">
    <customer-info :loading="false"/>
    <tab-header :current="currentTab"/>
    <div class="tab-content">
      <div class="container-fluid">
        <div class="tab-pane active show">
          <div class="form-group">
            <label><b>服務歷程(近三個月)：</b></label>
            <div class="radio radio-inline">
              <input type="radio" id="service-1" v-model="currentServiceTab" value="0">
              <label for="service-1">全部</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" id="service-2" v-model="currentServiceTab" value="客服諮詢">
              <label for="service-2">客服諮詢歷程</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" id="service-3" v-model="currentServiceTab" value="臨櫃諮詢">
              <label for="service-3">臨櫃諮詢歷程</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" id="service-4" v-model="currentServiceTab" value="線上遊覽">
              <label for="service-4">線上遊覽歷程</label>
            </div>
            <!--
            <div class="radio radio-inline">
              <input type="radio" id="service-5" v-model="currentServiceTab" value="4">
              <label for="service-5">車險預約單</label>
            </div>
            -->
          </div>
          <div class="insurance-row row" v-if="serviceShowList.length != 0" :class="{'section-loading': isLoading}">
            <table class="table datatable insurance-green" >
              <thead>
                <tr>
                  <th class="sorting" 
                      :class="(order.index==1 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="columnSorting(1)">接觸管道</th>
                  <th class="sorting" 
                      :class="(order.index==2 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="columnSorting(2)">行銷說明</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in serviceShowList" :key="`service-history-${i}`">
                  <td>{{item.channel}}</td>
                  <td>{{item.event_nm}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-center" colspan="6">
              <h3 class="mb-3"><center>查無資料</center></h3>
            </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';
import { commonMixin } from '../../mixins/common';
import { getServiceRecord } from '../../service/index';

import Avatar from '../../components/Avatar';
import CustomerInfo from '../components/CustomerDetail/CustomerInfo';
import TabHeader from '../components/CustomerDetail/TabHeader';

export default {
  name: 'CustomerDetail5',
  mixins: [commonMixin],
  data () {
    return {
      currentServiceTab: 0,
      currentTab: 0,
      serviceList: [],
      serviceShowList: [],
      isLoading: true,
      order: {
        index: 1,
        asc: true
      }
    }
  },
  components: { 
    Avatar, CustomerInfo, TabHeader, // basic component
  },
  computed: {
    ...mapGetters(['BaseUrl', 'UserInfo']),
    isBox() {
      // 判斷是否為 box
      return this.UserInfo.userType === 'box';
    }
  },
  watch: {
    'currentServiceTab': 'filterServiceList'
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ])
  },
  methods: {
    filterServiceList(val) {
      if (val == 0) {
        this.serviceShowList = this.serviceList.map(item => item)
      } else {
        this.serviceShowList = this.serviceList.filter(item => item.channel===val)
      }
    },
    initCustomerDetail5() {
      this.isLoading = true;
      getServiceRecord(this.$store.state.userInfo.id, this.$store.state.custInfo.ID).then(result =>{
        if(result.body.detail) {
          this.serviceList = result.body.detail.map((item, index) => {
            return {
              event_nm: item.event_nm ? item.event_nm : '',
              channel: item.channel || ''
            }
          })
          this.serviceShowList = this.serviceList.map(item => item);
          this.columnSorting(1);
        } else {
          this.serviceList = [];
          this.serviceShowList = [];
        }

        this.isLoading = false;
      })
    },
    columnSorting(i) {
      //切換表頭圖案
      if (this.order.index == i) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.asc = true;
      }
      this.order.index = i;

      //data排序
      switch (i) {
        case 1:
          this.serviceShowList.sort(this.sortCompareFun("channel"));
          break;
        case 2:
         this.serviceShowList.sort(this.sortCompareFun("event_nm"));
          break;
        default:
          break;
      }

      // for 難字 update
      let cacheList = [...this.serviceShowList];
      this.serviceShowList = [];
      this.isLoading = true;

      setTimeout(() => {
        this.serviceShowList = cacheList;
        this.registerHanlink();
        this.isLoading = false;
      }, 200)
    },
    sortCompareFun(mainProperty, subProperty = null) {
      let sortOrder = 1;
      if (!this.order.asc) {
        sortOrder = -1;
      }
      return function(a, b) {
        let result =
          a[mainProperty] < b[mainProperty] ? -1 : a[mainProperty] > b[mainProperty] ? 1 : 0;
        if (result == 0 && subProperty != null) {
          result = a[subProperty] < b[subProperty] ? -1 : a[subProperty] > b[subProperty] ? 1 : 0;
        }
        return result * sortOrder;
      };
    }
  },
  beforeMount () {
    let routeNumber = (this.$route.name.split(/-/g)).reverse()
    this.currentTab = Number(routeNumber[0])
  },
  async mounted () {
    this.initCustomerDetail5()
  }
}
</script>

<style scoped>
.boxPadding {
  padding-top: 0px !important;
}
</style>
